<template>
  <APaginateItems v-model="page" :items-meta="destinations?.meta">
    <div class="grid grid-cols-1 mt-2 sm:grid-cols-4 gap-x-4 gap-y-6">
      <template v-if="status === 'pending'">
        <USkeleton v-for="i in 20" :key="i" class="h-[210px] rounded-lg" />
      </template>
      <template v-else-if="destinations">
        <DestinationItem
          v-for="destination in destinations.data"
          :key="destination.id"
          :destination="destination"
        />
      </template>
    </div>
  </APaginateItems>
</template>

<script lang="ts" setup>
const route = useRoute()
const page = ref(route.query.page ? Number(route.query.page) : 1)

const {
  data: destinations,
  error: destinationsError,
  status,
} = await useFetch('/api/destinations/paginate', {
  query: {
    page,
  },
})

assertDefined(destinations, destinationsError)
</script>
